import { useState, useEffect } from "react";
import api from "@/lib/api";

/** Authenticated image fetcher that bypasses cookie issues by streaming via Authorization header. */
export default function AuthImage({ path, alt = "", className = "", testId }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoke = null;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        const url = URL.createObjectURL(res.data);
        revoke = url;
        setSrc(url);
      } catch (_e) {
        if (!cancelled) setError(true);
      }
    })();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (error) {
    return (
      <div className={`${className} flex items-center justify-center bg-obsidian`}>
        <p className="font-overline text-ash">unavailable</p>
      </div>
    );
  }
  if (!src) {
    return <div className={`${className} bg-obsidian animate-pulse`} data-testid={testId ? `${testId}-loading` : undefined} />;
  }
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
}
